import { useNavigate, useParams } from 'react-router-dom'
import { ChevronRight, LayoutDashboard, LogOut, User, Shield } from 'lucide-react'

import { EngineerLayout } from '../../components/layout/EngineerLayout'
import { usePermission } from '../../hooks/usePermission'

export function MorePage() {
  const navigate = useNavigate()
  const { tenantSlug } = useParams()
  const { can } = usePermission()

  return (
    <EngineerLayout hideHeader>
      <div className="px-4 pt-6 pb-4">
        <h1 className="text-xl font-semibold text-gray-900">More</h1>
      </div>

      <div className="px-4">
        <div className="bg-white rounded-lg border border-gray-200 divide-y divide-gray-200">
          {can('view_dashboard') && (
            <button
              onClick={() => navigate(`/${tenantSlug}/dashboard`)}
              className="w-full flex items-center justify-between px-4 py-3 min-h-[44px] text-left hover:bg-gray-50 active:bg-gray-100 transition-colors"
            >
              <div className="flex items-center gap-3">
                <LayoutDashboard className="w-5 h-5 text-gray-500" />
                <span className="text-sm font-medium text-gray-900">Dashboard</span>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400" />
            </button>
          )}

          <button
            onClick={() => navigate(`/${tenantSlug}/engineer/more/profile`)}
            className="w-full flex items-center justify-between px-4 py-3 min-h-[44px] text-left hover:bg-gray-50 active:bg-gray-100 transition-colors"
          >
            <div className="flex items-center gap-3">
              <User className="w-5 h-5 text-gray-500" />
              <span className="text-sm font-medium text-gray-900">Profile</span>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400" />
          </button>

          <button
            onClick={() => navigate(`/${tenantSlug}/engineer/more/security`)}
            className="w-full flex items-center justify-between px-4 py-3 min-h-[44px] text-left hover:bg-gray-50 active:bg-gray-100 transition-colors"
          >
            <div className="flex items-center gap-3">
              <Shield className="w-5 h-5 text-gray-500" />
              <span className="text-sm font-medium text-gray-900">Security</span>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400" />
          </button>

          <button
            onClick={() => navigate('/auth/logout')}
            className="w-full flex items-center justify-between px-4 py-3 min-h-[44px] text-left hover:bg-gray-50 active:bg-gray-100 transition-colors"
          >
            <div className="flex items-center gap-3">
              <LogOut className="w-5 h-5 text-gray-500" />
              <span className="text-sm font-medium text-gray-900">Sign out</span>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400" />
          </button>
        </div>
      </div>
    </EngineerLayout>
  )
}
